'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _timeUtil = require('../../../common/utils/timeUtil');

var _getClientConfig = require('../../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


var LOADING_TIME_MIN = (0, _getClientConfig2.default)().initialLoadDelay || 3000;
var QUOTE_FADE_DURATION = 300;

exports.default = function (DecoratedComponent) {
    var WorkspaceArtificialLoadingDelayDecorator = function (_React$Component) {
        _inherits(WorkspaceArtificialLoadingDelayDecorator, _React$Component);

        function WorkspaceArtificialLoadingDelayDecorator(props) {
            _classCallCheck(this, WorkspaceArtificialLoadingDelayDecorator);

            var _this = _possibleConstructorReturn(this, (WorkspaceArtificialLoadingDelayDecorator.__proto__ || Object.getPrototypeOf(WorkspaceArtificialLoadingDelayDecorator)).call(this, props));

            _this.finishLoading = function () {
                // don't set multiple delays if this method is called more than once
                if (!_this.state.loading) return;
                _this.setState({ loading: false });

                var timeNow = (0, _timeUtil.getTimestamp)();
                var loadingDifference = _this.startedLoading - timeNow;

                var delayQuote = Math.max(0, loadingDifference + LOADING_TIME_MIN);
                var delayLoader = delayQuote + QUOTE_FADE_DURATION;

                (0, _lodash.delay)(function () {
                    return _this.setState({ showLoaderQuote: false });
                }, delayQuote);
                (0, _lodash.delay)(function () {
                    return _this.setState({ showLoader: false });
                }, delayLoader);
            };

            _this.loadWithoutDelay = function () {
                _this.setState({
                    showLoaderQuote: false,
                    showLoader: false
                });
            };

            _this.state = {
                showLoader: true,
                showLoaderQuote: true,
                loading: true
            };
            return _this;
        }

        _createClass(WorkspaceArtificialLoadingDelayDecorator, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                this.startedLoading = window.__startedload || (0, _timeUtil.getTimestamp)();

                // for hot reloading
                if (this.props.isUserAvailable && !this.props.isGuest) this.loadWithoutDelay();
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.isUserAvailable && nextProps.currentBoard && nextProps.isCurrentBoardFetched || nextProps.isUserAvailable && nextProps.isCurrentBoardError) {
                    this.finishLoading();
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _state = this.state,
                    showLoader = _state.showLoader,
                    showLoaderQuote = _state.showLoaderQuote;


                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
                    showLoader: showLoader,
                    showLoaderQuote: showLoaderQuote }));
            }
        }]);

        return WorkspaceArtificialLoadingDelayDecorator;
    }(_react2.default.Component);

    WorkspaceArtificialLoadingDelayDecorator.propTypes = {
        isUserAvailable: _propTypes2.default.bool,
        isGuest: _propTypes2.default.bool
    };

    return WorkspaceArtificialLoadingDelayDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/decorators/workspaceArtificialLoadingDelayDecorator.js
// module id = 2154
// module chunks = 0